import { asArray } from "../utils/helpers";
import useRestaurantTables from "./useRestaurantTables";

const useFindTableById = (tableId: number) => {
  const tables = useRestaurantTables();
  return asArray(tables).find((t) => t.item_id === tableId);
};

export default useFindTableById;
